import React, { useEffect } from "react";

import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import GreyParentChild from "../../../../components/Tables/GreyParentChild";
import { OpeninMeter, resetOpeninMeter } from "../../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import Chart from "../../../../components/Charts/Chart";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";




export default function TotalMeter({ selectedProduction, selectedAccount }) {

  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { OpeninMeterdata } = useSelector((state) => state.GreyDashboardSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  const isNoData = !OpeninMeterdata?.Opening || OpeninMeterdata?.Opening.length === 0;

  useEffect(() => {
    dispatch(resetOpeninMeter())
    dispatch(OpeninMeter({
      groupIDs: selectedProduction.join(","),
      partyIDs: selectedAccount.join(",")
    }))
  }, [selectedProduction, selectedAccount])

  const formatFinancialYearFromRange = (range) => {
    if (!range) return "";

    // split "1/04/2024 - 31/03/2025"
    const parts = range.split("-");

    if (parts.length === 2) {
      const startPart = parts[0].trim(); // "1/04/2024"
      const endPart = parts[1].trim();   // "31/03/2025"

      const startYear = startPart.split("/").pop(); // 2024
      const endYear = endPart.split("/").pop().slice(-2); // 25

      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const yearLabel = formatFinancialYearFromRange(
    OpeninMeterdata?.Opening?.[0]?.FAcYear
  );

  const tableData = (OpeninMeterdata?.Opening || []).map(
    (row, index, arr) => ({
      srNumber: index + 1,
      FinancialYear: row.FinancialYear,
      OpInwMeter: row.OpInwMeter,
    })
  );

  const chartData1 = (OpeninMeterdata?.Opening || []).map((row) => ({
    month: row.FinancialYear,
    value: row.OpInwMeter
  }));

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Financial Year",
      key: "FinancialYear",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Meter (${yearLabel})`,
      key: "OpInwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];


  if (OpeninMeterdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row className="justify-content-center" style={{ margin: 0, padding: 0 }}>

        {/* ✅ CHART */}
        <Col xl={12} className=' p-0'>
          <Chart data={chartData1} title="Total Opening Meter" />
        </Col>

        {/* ✅ TABLE */}
        <Col xl={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color:
                  isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
              }}
            >
              <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight: "700" }}>
                TOTAL METER
              </h2>
              <p className="text-sm mt-1 mb-0">
                Financial Year: {yearLabel}
              </p>
            </div>

            <div style={{ backgroundColor: "#fff" }}>
              <GreyTable
                columns={columns}
                data={tableData}
                iscolourDark={iscolourDark}
                iscolour={iscolour}
              />
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  );
}